<template>
  <div class="footer-bar">
    <counters-block></counters-block>
    <template v-for="link in links">
      <router-link
        v-if="link.page && link.page !== $route.name"
        :to="{name: link.page}"
      >
        {{ link.title }}
      </router-link>
      <a
        v-if="link.link"
        :href="link.link"
      >
        {{ link.title }}
      </a>
    </template>
  </div>
</template>

<script>
import CountersBlock from '@/components/CountersBlock.vue'
export default {
  name: 'FooterBar',
  components: {
    CountersBlock
  },
  data () {
    return {
      links: [
        {
          title: 'О проекте',
          page: 'about'
        },
        {
          title: 'Вопросы и ответы',
          page: 'faq'
        },
        {
          title: 'Отзывы и предложения',
          link: 'http://art-jump.reformal.ru/proj/'
        },
        {
          title: 'Генератор ссылок',
          page: 'simple'
        },
        {
          title: 'Редактор статей (пробная версия)',
          page: 'editor'
        }
      ]
    }
  }
}
</script>
<style lang="sass" scoped>
.footer-bar
  height: 31px
  text-align: center
a
  padding: 0px 5px
</style>


// WEBPACK FOOTER //
// FooterBar.vue?0b8fdb4a